import React, { useContext } from "react";
import {
  EcAuthContext,
  EcUserDataContext,
  EcSidebar,
  hasOnlyOneActiveProduct
} from "@eclear-ag/ec-common-ui";

const MANAGE_ROUTE = { to: "/spot/manage-profile", name: "Manage" };
const DASHBOARD_ROUTE = { to: "/spot/", name: "SPOT Dashboard" };

/**
 * The SPOT sidebar. A user with one active product cannot open the SPOT
 * dashboard, so they get "Manage" instead.
 */
export default function SpotSidebar({ navigation }) {
  const { userData } = useContext(EcUserDataContext);
  const userSubscriptions = userData?.userInfo?.userSubscriptions ?? [];

  let menuRoute = DASHBOARD_ROUTE;
  if (hasOnlyOneActiveProduct(userSubscriptions)) {
    menuRoute = MANAGE_ROUTE;
  }

  return (
    <EcSidebar
      EcAuthContext={EcAuthContext}
      navigation={navigation}
      routes={[menuRoute]}
    />
  );
}
